import { object } from 'zod';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { makeZodValidate as makeValidate } from '@occc-app/design-system';

import {
  CONFIGURE_TAB,
  marketingContentFormSchema,
  qualifyingEventConfigurationFormSchema,
  receiverConfigurationFormSchema,
  senderConfigurationFormSchema,
} from './components';
import { ReferralProgramConfigurationValues } from './referral-program-configuration.types';
import { MessagingTab } from './referral-program-configuration.utils';

const configureTabSchema = object({
  sender: senderConfigurationFormSchema,
  receiver: receiverConfigurationFormSchema,
  qualifyingEvent: qualifyingEventConfigurationFormSchema,
}).strict();

const validateConfigureTab = makeValidate(configureTabSchema);
const validateMarketingContentTab = makeValidate(marketingContentFormSchema);

export const validateActiveTab = async (
  values: ReferralProgramConfigurationValues,
  activeTab: string,
  messagingTabs: MessagingTab[],
) => {
  if (activeTab === CONFIGURE_TAB) {
    return validateConfigureTab({
      sender: values.sender,
      receiver: values.receiver,
      qualifyingEvent: values.qualifyingEvent,
    });
  }

  const messagingTab = messagingTabs.find((tab) => tab.id === activeTab);

  if (!messagingTab) {
    return {};
  }

  const tabErrors = await validateMarketingContentTab(values.marketingContents[messagingTab.index]);

  if (Object.keys(tabErrors).length === 0) {
    return {};
  }

  return {
    marketingContents: {
      [messagingTab.index]: tabErrors,
    },
  };
};
